type MediaRequest = {
  audio: boolean
  video: boolean
  micId?: string
  camId?: string
}

/**
 * Device enumeration and stream disposal.
 *
 * `getUserMedia` deliberately does NOT live here any more. Capture of the
 * camera and microphone belongs to `device-manager.ts`, which is the single
 * owner of both; a general-purpose "open a stream" helper on a service anyone
 * could import is what let four different places decide what the user's camera
 * meant. The type below is kept because the manager speaks the same shape.
 */
export type { MediaRequest }

export const mediaStreamService = {
  isSupported(): boolean {
    return typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getUserMedia
  },

  async enumerateDevices(): Promise<MediaDeviceInfo[]> {
    if (!navigator.mediaDevices?.enumerateDevices) return []
    return navigator.mediaDevices.enumerateDevices()
  },

  stopStream(stream: MediaStream | null): void {
    if (!stream) return
    stream.getTracks().forEach((track) => track.stop())
  },
}
